import styled from 'styled-components';
import { colors } from '@/constants';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-bottom: 16px;
`;

export const SectionTitle = styled.h2`
    margin: 0 16px;
    font-size: 16px;
    font-weight: 700;
    color: ${colors.brand.grafite};
`;

export const ComboCard = styled.div`
    width: 100%;
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    background-color: ${colors.alert.green50};
    border: 1px solid ${colors.grey11};
    border-radius: 8px;
`;

export const ComboHeader = styled.div`
    display: flex;
    flex-direction: row;
    gap: 8px;
    align-items: center;
    cursor: pointer;

    &:active {
        opacity: 0.85;
    }
`;

export const ComboIcon = styled.div`
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    background-color: ${colors.alert.green100};
    flex-shrink: 0;
`;

export const ComboInfo = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
    flex: 1;
`;

export const ComboArrow = styled.div<{ $isExpanded: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    transition: transform 0.2s ease;
    transform: rotate(${({ $isExpanded }) => ($isExpanded ? 180 : 0)}deg);
`;

export const ComboDetails = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const ComboTitle = styled.span`
    font-size: 14px;
    font-weight: 700;
    color: ${colors.alert.green300};
    line-height: 120%;
`;

export const ComboDescription = styled.span`
    font-size: 12px;
    font-weight: 400;
    color: ${colors.brand.grafite};
    line-height: 120%;
`;

export const ComboMetrics = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
`;

export const ComboMetricItem = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
`;

export const ComboMetricLabel = styled.span`
    font-size: 11px;
    font-weight: 600;
    color: ${colors.brand.grafite};
`;

export const ComboMetricValue = styled.span<{ $color?: string }>`
    font-size: 13px;
    font-weight: 600;
    color: ${({ $color }) => $color || colors.brand.grafite};
`;

export const Divider = styled.div`
    width: 100%;
    height: 1px;
    background-color: ${colors.grey11};
`;
